import { CSSProperties, memo } from 'react';
import { Avatar, type AvatarProps } from '@ets/design-system';
import useAvatar from '_common/hooks/useAvatar';

export type UserAvatarProps = {
  userId: UserId;
  showTooltip?: boolean;
  userProfile?: Profile;
} & Partial<Pick<AvatarProps, 'size' | 'color' | 'online' | 'ringColor'>> &
  Pick<CSSProperties, 'margin'>;

const UserAvatar = ({
  userId,
  showTooltip,
  userProfile,
  online,
  size = 'm',
  color,
  margin,
}: UserAvatarProps) => {
  const avatarProps = useAvatar(userId, { showTooltip, userProfile });

  return (
    <Avatar
      size={size}
      color={color ?? avatarProps.ringColor ?? 'blue'}
      tooltip={avatarProps.tooltip}
      imageSrc={avatarProps.imageSrc}
      ringColor={avatarProps.ringColor}
      online={online}
      style={{ margin }}
      testId={userId}
    >
      {avatarProps.children}
    </Avatar>
  );
};

export default memo(UserAvatar);
